import { Pipe, PipeTransform } from '@angular/core';
import { Validators } from '@angular/forms';
import { GalaxyInputValidator } from '@vendasta/galaxy/input';
import { convertHTMLControlValueToNumber } from '../../item-pricing-table/item-pricing-table.utils';

@Pipe({ name: 'priceValidator' })
export class PriceValidatorPipe implements PipeTransform {
  transform(minimumPrice: number): GalaxyInputValidator[] {
    const required: GalaxyInputValidator = {
      validatorFn: Validators.required,
      errorMessage: 'Required',
    };
    const minValue: GalaxyInputValidator = {
      validatorFn: (control) => {
        const convertedPrice = convertHTMLControlValueToNumber(control.value);
        if (convertedPrice < minimumPrice) {
          return { min: true };
        }
        return null;
      },
      errorMessage: 'Cannot be lower than minimum',
    };
    return [required, minValue];
  }
}
